import type { Odds as OddsType } from '@ps/isp-web-services-types';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { Icon, Odds } from '@swf/sports/components';

import {
  TXTWCL_Added_To_Bet_Slip,
  TXTWCL_SP,
  TXTWCL_SUSPENDED,
  TXTWCL_Starting_Price,
  TXTWCL_handicap_value_N0
} from './Content.messages.json';
import styles from './Content.scss';

export interface OwnProps {
  odds?: OddsType;
  isLocked: boolean;
  selectionText?: string;
  isNonRunner?: boolean;
  isStartingPriceMarket: boolean;
  isHandicap?: boolean;
  isVacantTrap?: boolean;
  shouldShowAddedToBetSlip?: boolean;
}

export type Props = OwnProps;

const Content: React.FC<Props> = (props) => {
  const { formatMessage } = useRegulatoryIntl();

  const {
    odds,
    isLocked,
    selectionText,
    isNonRunner,
    isStartingPriceMarket,
    isHandicap,
    isVacantTrap,
    shouldShowAddedToBetSlip
  } = props;

  if (isNonRunner || isVacantTrap) return <>-</>;

  if (isLocked) {
    return <Icon name="padlock" size="xl" label={formatMessage(TXTWCL_SUSPENDED)} />;
  }

  if (!odds) {
    return isStartingPriceMarket ? (
      <strong aria-label={formatMessage(TXTWCL_Starting_Price)}>
        <Translation {...TXTWCL_SP} />
      </strong>
    ) : (
      <>-</>
    );
  }

  return (
    <span className={styles.selectionContent}>
      <strong>
        {shouldShowAddedToBetSlip ? (
          <Translation {...TXTWCL_Added_To_Bet_Slip} />
        ) : (
          <Odds {...odds} />
        )}
      </strong>
      {selectionText && (
        <span
          aria-label={
            isHandicap ? formatMessage(TXTWCL_handicap_value_N0, { 0: selectionText }) : undefined
          }
        >
          {selectionText}
        </span>
      )}
    </span>
  );
};

export default Content;
